import { Component, Input } from '@angular/core';

@Component({
  selector: 'molecule-progress-indicators',
  templateUrl: './progress-indicators.component.html',
  styleUrls: ['./progress-indicators.component.scss'],
})
export class ProgressIndicatorsComponent {
  @Input() progressPercentage: number = 0;
  @Input() progressResult?:string | number;
  @Input() progressTitle?:string;
  @Input() progressTooltip?:string;
}
